// extracted by mini-css-extract-plugin
export default {"card":"Game_card__UdHSl","disabled":"Game_disabled__ZJYz0"};